export default __webpack_public_path__ + "static/pinterest-03e60e46259dcaa9af77972c5578bf9c.svg";